<template>
  <div>
    <b-overlay
      :show="loading"
      rounded="lg"
    >
      <b-breadcrumb>
        <b-breadcrumb-item>
          <b-icon
            icon="house-fill"
            scale="1.25"
            shift-v="1.25"
            aria-hidden="true"
          ></b-icon>
        </b-breadcrumb-item>
        <b-breadcrumb-item active>PickList History</b-breadcrumb-item> </b-breadcrumb
      ><br />
      <b-card title="PickList History">
      <!-- Modal for showing Details -->
        <div>
          <b-row>
            <b-col cols="12" md="4">
              <b-form-group>
                <label for="selectOption">Send Type</label>
                <v-select
                  
                  :clearable="false"
                  id="selectOption"
                  v-model="selectedSendType"
                  label="text"
                  :options="jobList"
                  :reduce="option => option.value"
                  placeholder="Select Send Type"
                >
                </v-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <div>
                <label for="date-created">Date Created</label>
                <b-form-datepicker
                  id="date-created"
                  placeholder="Search by Date Created"
                  v-model="dateCreated"
                  reset-button
                  reset-button-variant="primary"
                />
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <label for="order-number-input">Order Number</label>
              <b-form-input
                id="order-number-input"
                v-model="search"
                type="search"
                placeholder="Type to Search"
                style="float: right;"
              />
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <b-col cols="auto" class="mb-2 mr-2">
              <b-button
                class="primary"
                @click="searchbtn"
              >
                Search
              </b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div style="overflow-x: visible;">
              <b-table
                hover
                outlined
                responsive
                head-variant="dark"
                show-empty
                small
                :per-page="perPage"
                :items="picklists"
                :fields="table_fields"
                :stacked="stackedStatus"
              >
                <template v-slot:cell(action)="row">
                  <b-dropdown variant="success" size="sm" text="Menu" no-caret>
                    <template #button-content>
                      <feather-icon size="1x" icon="MenuIcon" />
                    </template>
                    <b-dropdown-item>
                      <b-button
                        variant="success"
                        size="sm"
                        @click="detail(row.item)"
                        style="margin-right:10px"
                        ><feather-icon size="1x" icon="EyeIcon"
                      /></b-button>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" class="pt-1">
            <b-form-group
              label="Data Per Page"
              label-for="per-page-select"
              label-cols-md="0"
              label-align-sm="left"
              label-size="md"
              class="mb-0"
            >
              <v-select
                class="select-sm"
                :clearable="false"
                id="per-page-select"
                v-model="perPage"
                @change="onPerPageChange"
                :options="pageOptions"
                size="sm"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col class="pt-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              @change="onPageChange"
              first-number
              last-number
              class="float-right"
              aria-controls="user-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
  </b-overlay>
  <b-modal v-model="showDetailModal" title="Pick List Detail" size="md" ok-only >
    <b-row>
      <b-col cols="6">
        Stock Balance :
      </b-col>
      <b-col cols="6">
        {{detailModal.stockBalance}}
      </b-col>
      <b-col cols="6">
        Warehouse :
      </b-col>
      <b-col cols="6">
        {{detailModal.warehouse}}
      </b-col>
      <b-col cols="6">
        Bin Location :
      </b-col>
      <b-col cols="6">
        {{detailModal.binLocation}}
      </b-col>
      <b-col cols="6">
        Created at :
      </b-col>
      <b-col cols="6">
        {{detailModal.createdAt}}
      </b-col>
      <b-col cols="6">
        Updated at :
      </b-col>
      <b-col cols="6">
        {{detailModal.updatedAt}}
      </b-col>
      <b-col cols="6">
        Order Handler :
      </b-col>
      <b-col cols="6">
        {{detailModal.orderHandler}}
      </b-col>
      <b-col cols="6">
        PickList Line :
      </b-col>
      <b-col cols="6">
        {{detailModal.picklistLine}}
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100">    
      </div>
    </template>
  </b-modal>
  </div>
</template>

<script>
import picklist from "@/store/picklist";
import {
  dateFormat,
  userAccess
} from "@/utils/utils.js";

import vSelect from "vue-select";
import { mapActions } from "vuex";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      loading: false,
      stackedStatus: "md",
      selectedSendType: null,
      dateCreated: null,
      jobList: [
        { value: null, text: "All" },
        { value: "New", text: "New" },
        { value: "Done", text: "Done" },
        //{ value: "Cancel", text: "Cancel" },
      ],
      showDetailModal: false,
      detailModal: "",
      search: null,
      pageOptions: [5, 10, 20, 100],
      perPage: 5,
      currentPage: 1,
      rows: 1,
      table_fields: [
        {
          key: "orderNumber",
          label: "SO Number",
          filterable: true,
          sortable: true,
        },
        {
          key: "pickListLineNumber",
          label: "Pick List Number",
          filterable: true,
          sortable: true,
        },
        {
          key: "lineItemDescription",
          label: "Line item and Description",
          filterable: true,
          sortable: true,
        },
        {
          key: "quantity",
          label: "Quantity",
          filterable: true,
          sortable: true,
        },
        {
          key: "unit",
          label: "Unit",
          filterable: true,
          sortable: true,
        },
        {
          key: "fromBatch",
          label: "From Batch",
          filterable: true,
          sortable: true,
        },
        {
          key: "toBatch",
          label: "To Batch",
          filterable: true,
          sortable: true,
        },
        {
          key: "cuttingNumber",
          label: "Cutting Number",
          filterable: true,
          sortable: true,
        },
        {
          key: "remark",
          label: "Remark",
          filterable: true,
          sortable: true,
        },
        {
          key: "pickListType",
          label: "Type",
          filterable: true,
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value, key, item) => {
            if(item.pickListType == "C"){
              return "Cutting"
            }else if(item.pickListType == "R"){
              return "Recoil"
            }else if(item.pickListType == "S"){
              return "Direct Sales"
            }else{
              return item.pickListType
            }
          },
        },
        "action",
      ],
    };
  },
  watch: {
    // Taking the Menu Setting from localstorage session so the setting will be the same as before
    perPage(perPageNew) {
      this.$session.set("perPagePicklistHistoryManufacture", perPageNew);
    },
  },
  methods: {
    ...mapActions({
      picklistData: "picklist/getPicklist",
    }),
    searchbtn() {
      this.loadPicklistData()
    },
    onPageChange(data) {
      this.currentPage = data
      this.loadPicklistData()
    },
    onPerPageChange(data){
      this.currentPage = 1
      this.loadPicklistData()

    },
    loadPicklistData() {
      this.loading = true
      let searchText = null
      if (this.search !== "") {
        searchText = this.search
      }
      this.picklistData({ 
        orderNumber: searchText,
        dateCreated: this.dateCreated,
        sendType: this.selectedSendType,
        page: this.currentPage,
        entry: this.perPage
      }).then((res) => {
        this.rows = res.metadata.totalData
        this.currentPage = res.metadata.page + 1
        this.rows = res.metadata.totalData
        this.loading = false
      }).catch((e) => {
        this.$bvToast.toast("Load data failed, please reload the page.", {
        title: "Warning",
        variant: "danger",
        solid: true,
        });
        console.log(e);
        this.loading = false
        });
    },
    detail(item){
      var newCreated = dateFormat(item.createdAt).split(",")
      var newUpdated = dateFormat(item.updatedAt).split(",")
      this.detailModal = item,
      this.detailModal.createdAt = newCreated[0] + newCreated[1].replace(/\./g, ':'),
      this.detailModal.updatedAt = newUpdated[0] + newUpdated[1].replace(/\./g, ':'),
      this.showDetailModal=true;
    },
  },
  computed: {
    permission() {
      return userAccess("picklist history");
    },
    picklists() {
      var data = this.$store.getters["picklist/getPicklist"]
      .map(
        (el) => {
          return {
            ...el,
            pickListLineNumber: el.picklistNo + "_" + el.picklistLine,
            lineItemDescription: el.lineItem + " " + el.lineDescription,
            statusCheckBox: false,
          };
        }
      );
      return data
    },
  },
  beforeDestroy() {
    this.$store.dispatch("picklist/resetPicklist");
  },
  mounted() {
    this.$store.dispatch("picklist/resetPicklist");
    // Saving Menu Setting on localstorage session so it still same even after reloading the page
    if (this.$session.has("perPagePicklistHistoryManufacture")) {
      this.perPage = this.$session.get("perPagePicklistHistoryManufacture");
    }
  },
};
</script>

<style>
.select-sm .vs__dropdown-toggle {
  min-height: 30px;
}
</style>